import {getMethod} from '@/api'

async function get(params) {
    return await getMethod('/api/searchAccommodationResults', params, null, {responseType: 'arraybuffer'})
}

export {get}
